import { createContext } from "react";
import type { Peer } from "../../lib/relative";

export type AddRelativePeers = (peers: Peer[], source: string) => void;
export const AddRelativePeersContext = createContext<AddRelativePeers | undefined>(undefined);
